<imv-dialog [i18n]="i18n"></imv-dialog>
<imv-dialog-confirm [i18n]="i18n"></imv-dialog-confirm>
<imv-dialog-with-control [i18n]="i18n"></imv-dialog-with-control>
<imv-dialog-saved [i18n]="i18n"></imv-dialog-saved>
